export const LABEL_WIDTH = 135;
export const IconButtonType = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TRANSPARENT: 'transparent'
};
export const IconButtonColor = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary'
};
export const IconButtonBackgroundOpacity = {
  OPACITY_00: '00',
  OPACITY_10: '1A',
  OPACITY_20: '33',
  OPACITY_30: '4D',
  OPACITY_100: 'FF'
};
export const IconButtonIconSize = {
  SIZE_16: 16,
  SIZE_24: 24
};
export const ALLOWED_ICON_BUTTON_COLORS = Object.values(IconButtonColor);